import { useState, useCallback, useEffect } from 'react';
import { ProjectApi, ToastStateHandler } from '../../../api';
import { ProjectFileWithPresignedUrlDto } from '../../../commonTypes/project.types';
import { useContainer } from '../../useContainer';
import { useTranslation } from '../../useTranslation';

const useHttpGetProjectFiles = (projectId: string) => {
    const { t } = useTranslation('newNotifications');
    const projectApi: ProjectApi = useContainer(ProjectApi);
    const [projectFiles, setProjectFiles] = useState<ProjectFileWithPresignedUrlDto[]>([]);
    const [areProjectFilesReady, setProjectFilesReady] = useState<boolean>(false);

    const toastHandler: ToastStateHandler = useContainer(ToastStateHandler);

    const fetchProjectFiles = useCallback(() => {
        const { exec, abort } = projectApi.getFilesForProject({
            params: { projectId },
            onSuccess: res => setProjectFiles(res.body),
            onError: _ => toastHandler.push('error', t('common.error'), t('common.somethingWentWrong')),
            onFinally: () => setProjectFilesReady(true),
        });
        exec();
        return abort;
    }, [projectApi, toastHandler, t]);

    useEffect(() => {
        fetchProjectFiles();
    }, [fetchProjectFiles]);

    return { projectFiles, areProjectFilesReady, exec: fetchProjectFiles };
};

export default useHttpGetProjectFiles;
